import React from 'react'

export const AssessmentIcon = ({
  width = 20,
  height = 20,
  fill = '#282828'
}: {
  width?: number
  height?: number
  fill?: string
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill={fill}
    >
      <path
        d="M5.83333 12.5002H11.6667V14.1668H5.83333V12.5002ZM5.83333 9.16683H14.1667V10.8335H5.83333V9.16683ZM5.83333 5.8335H14.1667V7.50016H5.83333V5.8335ZM15.8333 2.50016H12.35C12 1.5335 11.0833 0.833496 10 0.833496C8.91667 0.833496 8 1.5335 7.65 2.50016H4.16667C4.05 2.50016 3.94167 2.5085 3.83333 2.5335C3.50833 2.60016 3.21667 2.76683 2.99167 2.99183C2.84167 3.14183 2.71667 3.32516 2.63333 3.52516C2.55 3.71683 2.5 3.9335 2.5 4.16683V15.8335C2.5 16.0585 2.55 16.2835 2.63333 16.4835C2.71667 16.6835 2.84167 16.8585 2.99167 17.0168C3.21667 17.2418 3.50833 17.4085 3.83333 17.4752C3.94167 17.4918 4.05 17.5002 4.16667 17.5002H15.8333C16.75 17.5002 17.5 16.7502 17.5 15.8335V4.16683C17.5 3.25016 16.75 2.50016 15.8333 2.50016ZM10 2.29183C10.3417 2.29183 10.625 2.57516 10.625 2.91683C10.625 3.2585 10.3417 3.54183 10 3.54183C9.65833 3.54183 9.375 3.2585 9.375 2.91683C9.375 2.57516 9.65833 2.29183 10 2.29183ZM15.8333 15.8335H4.16667V4.16683H15.8333V15.8335Z"
        fill="#282828"
      />
    </svg>
  )
}
